export default {
  name: "LoadingAnimation",
  props: {
    visible: Boolean,
    message: String,
  },
  data() {
    return {};
  },
};
